import { Route, Routes } from "react-router-dom";
import BaseRequirementsIDPage from "../../app/base-requirements/id";
import CreateBaseRequirementPage from "../../app/base-requirements/create";
import BaseRequirementsPage from "../../app/base-requirements";

export default function BaseRequirementsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<BaseRequirementsPage />} />
      <Route path="/:id" element={<BaseRequirementsIDPage />} />
      <Route path="/create" element={<CreateBaseRequirementPage />} />
    </Routes>
  );
}
